import { render } from "./FormTokens.vue?vue&type=template&id=c899b2ca&scoped=true"
import script from "./FormTokens.vue?vue&type=script&lang=js"
export * from "./FormTokens.vue?vue&type=script&lang=js"

import "./FormTokens.vue?vue&type=style&index=0&id=c899b2ca&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c899b2ca"

export default script